import { cn } from '@/lib/utils';
import type { BuildSettingChip, BuildSettingUrl } from './build-settings';

export function BuildSettingChips({ chips }: { chips: BuildSettingChip[] }) {
	if (chips.length === 0) return null;

	return (
		<div className='flex flex-wrap gap-1'>
			{chips.map(chip => (
				<span
					key={chip.key}
					className={cn(
						'inline-flex max-w-full items-center truncate rounded-md px-1.5 py-0.5 text-[11px] font-medium',
						chip.enabled ? 'bg-chart-2/15 text-chart-2' : 'bg-muted text-muted-foreground',
					)}
					title={chip.label}
				>
					{chip.label}
				</span>
			))}
		</div>
	);
}

export function BuildSettingUrls({ urls }: { urls: BuildSettingUrl[] }) {
	if (urls.length === 0) return null;

	return (
		<div className='flex flex-col gap-0.5'>
			{urls.map(url => (
				<p key={url.key} className='truncate font-mono text-xs text-muted-foreground' title={url.href}>
					{url.href}
				</p>
			))}
		</div>
	);
}

export function BuildTechLine({ parts }: { parts: string[] }) {
	if (parts.length === 0) return null;

	return (
		<p className='truncate text-xs text-muted-foreground' title={parts.join(' · ')}>
			{parts.join(' · ')}
		</p>
	);
}
